import { Autocomplete, FormHelperText, Paper, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Field } from 'formik';

export default function ParentDetailsSection({
  touched,
  errors,
  countryCodeAndCountry,
  loading,
  values,
  setFieldValue,
}) {
  return (
    <Paper elevation={3} sx={{ p: 4 }}>
      <Typography variant="h4" mb={6}>
        Parent Details
      </Typography>

      <Box display={'flex'} gap={2} flexDirection="column" maxWidth={900}>
        <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            id="fatherName"
            label="Father Name"
            name="fatherName"
            error={touched.fatherName && Boolean(errors.fatherName)}
            helperText={touched.fatherName && errors.fatherName}
          />
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            id="fatherQualification"
            label="Father Qualification"
            name="fatherQualification"
            error={touched.fatherQualification && Boolean(errors.fatherQualification)}
            helperText={touched.fatherQualification && errors.fatherQualification}
          />
        </Box>
        <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            label="Father Occupation"
            name="fatherOccupation"
            error={touched.fatherOccupation && Boolean(errors.fatherOccupation)}
            helperText={touched.fatherOccupation && errors.fatherOccupation}
          />
          <Box display={'flex'} gap={2} width={'100%'}>
            <Autocomplete
              fullWidth
              disabled={loading}
              name="fatherCountryCode"
              id="fatherCountryCode"
              options={countryCodeAndCountry}
              onChange={(_, v) => setFieldValue('fatherCountryCode', v?.phone_code)}
              getOptionLabel={(option) => option.label || ''}
              value={countryCodeAndCountry?.find((CNTRY) => CNTRY.phone_code == values.fatherCountryCode) || null}
              renderInput={(params) => (
                <TextField
                  disabled
                  fullWidth
                  autoComplete="off"
                  {...params}
                  label="Father Country Code"
                  error={touched.fatherCountryCode && Boolean(errors.fatherCountryCode)}
                  helperText={touched.fatherCountryCode && errors.fatherCountryCode}
                />
              )}
            />
            <Field
              as={TextField}
              autoComplete="off"
              fullWidth
              type="number"
              id="fatherContactNumber"
              label="Father Contact Number"
              name="fatherContactNumber"
              error={touched.fatherContactNumber && Boolean(errors.fatherContactNumber)}
              helperText={touched.fatherContactNumber && errors.fatherContactNumber}
            />
          </Box>
        </Box>
        <Field
          as={TextField}
          autoComplete="off"
          fullWidth
          id="fatherAnnualIncome"
          label="Father Annual Income"
          type="number"
          name="fatherAnnualIncome"
          sx={{ maxWidth: 250 }}
          error={touched.fatherAnnualIncome && Boolean(errors.fatherAnnualIncome)}
          helperText={touched.fatherAnnualIncome && errors.fatherAnnualIncome}
        />
        <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            id="motherName"
            label="Mother Name"
            name="motherName"
            error={touched.motherName && Boolean(errors.motherName)}
            helperText={touched.motherName && errors.motherName}
          />
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            id="motherQualification"
            label="Mother Qualification"
            name="motherQualification"
            error={touched.motherQualification && Boolean(errors.motherQualification)}
            helperText={touched.fatherQualification && errors.fatherQualification}
          />
        </Box>
        <Box display="flex" gap={2} flexDirection={{ xs: 'column', sm: 'row' }} width={'100%'}>
          <Field
            as={TextField}
            autoComplete="off"
            fullWidth
            id="motherOccupation"
            label="Mother Occupation"
            name="motherOccupation"
            error={touched.motherOccupation && Boolean(errors.motherOccupation)}
            helperText={touched.motherOccupation && errors.motherOccupation}
          />
          <Box display={'flex'} gap={2} width={'100%'}>
            <Autocomplete
              fullWidth
              disabled={loading}
              name="motherCountryCode"
              id="motherCountryCode"
              options={countryCodeAndCountry}
              onChange={(_, v) => setFieldValue('motherCountryCode', v?.phone_code)}
              getOptionLabel={(option) => option.label || ''}
              value={countryCodeAndCountry?.find((CNTRY) => CNTRY.phone_code == values.motherCountryCode) || null}
              renderInput={(params) => (
                <TextField
                  // as={TextField}
                  disabled
                  fullWidth
                  autoComplete="off"
                  {...params}
                  label="Mother Country Code"
                  error={touched.motherCountryCode && Boolean(errors.motherCountryCode)}
                  helperText={touched.motherCountryCode && errors.motherCountryCode}
                />
              )}
            />
            <Field
              as={TextField}
              autoComplete="off"
              fullWidth
              type="number"
              id="motherMobileNumber"
              label="Mother Contact Number"
              name="motherMobileNumber"
              error={touched.motherMobileNumber && Boolean(errors.motherMobileNumber)}
              helperText={touched.motherMobileNumber && errors.motherMobileNumber}
            />
          </Box>
        </Box>
        <Field
          as={TextField}
          autoComplete="off"
          fullWidth
          id="motherAnnualIncome"
          label="Mother Annual Income"
          type="number"
          name="motherAnnualIncome"
          sx={{ maxWidth: 250 }}
          error={touched.motherAnnualIncome && Boolean(errors.motherAnnualIncome)}
          helperText={touched.motherAnnualIncome && errors.motherAnnualIncome}
        />
      </Box>
    </Paper>
  );
}
